import Big from 'big.js';

export const calculateLineItemTotal = (total = 0, discount = 0) => {
  const result = Number(Big(total).sub(discount));
  return result < 0 ? 0 : result;
};

export const hasDiscount = (discount) => Number(discount) > 0;
